/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

var dialog = Magix.addView("@ali/cell-dialog@0.0.17",__webpack_require__(1));;

var Util = {};

var webp = function () {
  var cblist = [];
  var state;

  if (/(iPad|iPod|iPhone|MSIE[\s\d\.]+);/i.test(navigator.userAgent)) {
    state = 0;
  } else {
    var onComplate = function onComplate(s) {
      state = !!s;
      for (var i = 0; i < cblist.length; i++) {
        cblist[i](state);
      };
    };
    var img = new Image();
    img.onload = function () {
      onComplate(1);
    };
    img.onerror = function () {
      onComplate(0);
    };
    img.src = "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAgA0JaQAA3AA/vuUAAA=";
  }
  return function (cb) {
    if (typeof cb == "function") {
      typeof state != "undefined" ? cb(state) : cblist.push(cb);
    }
  };
}();
if (window._WEBP === void 0) {
  webp(function (state) {
    window._WEBP = state;
  });
}

// 扩展安全参数
// http://gitlab.alibaba-inc.com/sd/ctlv/wikis/home
Util.safe = function () {
  window.C_T_L = window.ctl;
  var client = window.ctl; // && window.ctl.noConflict() || {}
  client && client.config && client.config();
  return client;
}();

Util.accPlus = function (arg1, arg2) {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m + arg2 * m) / m).toFixed(n);
};

Util.dialog = function (params) {
  if (!$.isPlainObject(params)) {
    params = {
      content: params
    };
  }

  dialog.create({
    options: {
      pos: 'top',
      animated: 'slideInRight',
      content: params.msg,
      show: true
    }
  });
};

Util.mtop = function (url, data, callback, extendParams, version) {
  if (!window.lib && !window.lib.mtop) {
    alert('need mtop lib js in page');
    return;
  }
  var requestData = {
    "api": url,
    "v": version || "1.0",
    "AntiCreep": true,
    "data": data,
    "dataType": 'jsonp',
    "type": "GET",
    "ecode": '0'
  };
  if (extendParams) {
    $.extend(requestData, extendParams);
  }
  // 优先使用东溟那边的mtop,会带上监控，否则使用普通的
  if (window.MM_MTOP) {
    window.MM_MTOP.send(requestData, function (res) {

      var data = res.data;
      if (data.model) data = data.model; // 后端mock数据有问题，先临时处理

      // console && console.log('requestData' + JSON.stringify(data))

      callback(null, data);
      // callback({})
    }, function (error) {

      // console && console.log('requestDataerror' + JSON.stringify(error))

      var message = error;
      var errorCode = '';
      if (error && error.ret) {
        message = error.ret[0].split('::')[1] || '';
        errorCode = error.ret[0].split('::')[0];
      }

      // 未登录直接跳转登录
      if (errorCode === 'FAIL_SYS_SESSION_EXPIRED' || errorCode === 'ERR_SID_INVALID') {
        lib.login.goLogin();
        return;
      }
      if (data.defaultErrorhandle) {

        message = message || 'error';
        Util.dialog(message);
        return;
      }
      callback(error);
    });
  } else {
    lib.mtop.request(requestData, function (res) {
      var code = res.ret[0].split('::')[0];
      var success = code === 'SUCCESS';
      if (!success) {
        // res.code = code
        callback(res);
        if (data.defaultErrorhandle) Util.toast(res);
      } else {
        callback(null, res.data);
        //其他代码执行引起的错误
      }
    });
  }
};

Util.joinParams = function (obj) {
  var res = [],
      s = function s(k, v) {
    var k = encodeURIComponent(k),
        v = encodeURIComponent(v);
    if (k || v) {
      res.push(k + (v == "" ? "" : "=" + v));
    }
  };
  for (var k in obj) {
    var v = obj[k];
    if (v && v.constructor == Array) {
      for (var i = 0, len = v.length; i < len; i++) {
        s(k, v[i]);
      }
    } else {
      s(k, v);
    }
  }
  return res.join("&");
};

Util.parseParams = function (str) {
  var p = {};
  if (str) {
    for (var i = 0, s, d = str.split(/&+/), len = d.length; i < len; i++) {
      if (s = d[i]) {
        var k = Util.decodeURIComponent(s.replace(/=.*/, "")),
            v = Util.decodeURIComponent(s.replace(/(.*?=)|(.*)/, ""));
        if (k || v) {
          if (k in p) {
            if (typeof p[k] == "string") p[k] = [p[k]];
            p[k].push(v);
          } else {
            p[k] = v;
          }
        }
      }
    }
  }
  if (p.pid && $.isArray(p.pid)) {
    p.pid = p.pid[0];
  }
  return p;
};

// %dd 这样就会报 URI malformed 异常
Util.decodeURIComponent = function (str) {
  try {
    return decodeURIComponent(str);
  } catch (e) {
    return "";
  }
};

Util.searchObj = function () {
  return Util.parseParams(window.location.search.replace(/^\?+/, ""));
}();

Util.isLogin = function () {
  if (!lib.login) return false;
  return lib.login.isLogin();
};

Util.appendParams = function (url, params) {
  var str = Util.joinParams(params);
  if (url.indexOf('?') !== -1) {
    url += '&' + str;
  } else {
    url += '?' + str;
  }
  return url;
};

Util.fixDomain = function (url) {
  // 针对预发环境作出处理
  // h5.m.taobao.com  => wapp.m.taobao.com  并且加上 systype= wapa
  // mo.m.taobao.com => 加上  systype= wapa & preview= 1
  // 并且全部改成http
  if (!/(h5|wapp|mo|mos)\.m\.taobao\.com/.test(url)) return url;

  var env = 'online';
  if (location.href.indexOf('wapp') !== -1 || location.href.indexOf('preview=1') !== -1) {
    env = 'pre';
  }

  if (env !== 'online') {
    url = url.replace('h5.m.taobao.com', 'wapp.m.taobao.com');
    url = url.replace('https', 'http');

    url = Util.appendParams(url, {
      'preview': '1'
    });
  }

  if (Util.searchObj.systype) {
    // systype 做透传
    url = Util.appendParams(url, {
      'systype': Util.searchObj.systype
    });
  }

  return url;
};

Util.sync = function (url, params, sucessfn, errfn) {
  $.ajax({
    url: Util.appendParams(url, params),
    dataType: 'jsonp',
    jsonp: 'cb',
    data: '',
    success: function success(data, status, xhr) {
      if (data) {
        sucessfn && sucessfn(data);
      } else {
        sucessfn && sucessfn(null, data);
      }
    },
    error: function error(xhr, msg) {
      errfn && errfn(msg);
    }
  });
};

module.exports = Util;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/**
 * 对话框
 * @author weikang.zhuwk@alibaba-inc.com
 *
 * @param {string} [title] 标题默认为空 ''
 * @param {boolean} [show] 是否直接显示 false
 * @param {string} [view] 是否使用子view ''
 * @param {string} [viewOptions] 子view的配置参数
 * @param {string} [content] 内容 ''
 * @param {boolean} [preventScroll] 是否阻止背景滚动 true
 * @param {string} [closable] 是否显示右上角的关闭按钮 true
 * @param {string} [closeDestroy] 关闭弹框是不是自动销毁 false
 * @param {string} [maskClosable] 是否点击蒙层关闭 true
 * @param {string} [animate] 动画 为空则没有动画 可选 
 * @param {string} [elCls] 根节点class名 ''
 * @param {num} [zIndex] z-index的值
 * @param {string} [width] 弹框的宽度 '80%'
 * @param {string} [height] 弹框的高度 auto
 * @param {string} [autoCloseMs] 间隔autoCloseMs后自动关闭，默认不自动关闭 ''
 * @param {string} [pos] dialog显示位置，可选值[top|left|right|bottom]，默认水平垂直居中, ''
 * @param {boolean} [showMask] 是否显示mask true
 * @param {string} [cancelBtnMsg] 取消按钮文案
 * @param {string} [okBtnMsg] 确认按钮文案
 *
 * @event {string} [close] 关闭弹框事件
 * @event {string} [open] 打开弹框事件
 *
 * @method [open] 打开弹框
 * @method [close] 关闭弹框
 * @method [setHtml] 更换内容
 *
 * @static create 以一个初始化配置创建一个对话框
 *
 */
var posAniMap = {
  top: 'slideInTop',
  right: 'slideInRight',
  bottom: 'slideInBottom',
  left: 'slideInLeft'
};

Magix.applyStyle("mx-af-cell-dialog", ".cell-dialog-hide body{position:fixed;width:100%}.cell-dialog-wrap{display:none;position:fixed;overflow:auto;top:0;right:0;bottom:0;left:0;height:100%;-webkit-overflow-scrolling:touch;outline:0;opacity:0;background-color:rgba(34,34,34,.6);transition:opacity .3s;z-index:999}.cell-dialog-wrap.no-mask{background-color:transparent}.cell-dialog-wrap .cell-dialog{width:80%;position:relative;background:#fff;border-radius:.1rem;font-size:.36rem;overflow:hidden}.cell-dialog-wrap .cell-dialog .cell-dialog-title{text-align:center;font-size:.4rem;padding:.2rem}.cell-dialog-wrap .cell-dialog .cell-dialog-content{padding:.2rem .4rem}.cell-dialog-wrap .cell-dialog .cell-dialog-close{position:absolute;right:3%;top:5%;color:#333;height:.4rem;line-height:.4rem}.cell-dialog-wrap .cell-dialog .cell-dialog-close:after{content:\"\\D7\";font-weight:100;font-size:.4rem}.cell-dialog-wrap .cell-dialog-btns{display:-webkit-box;display:box;display:flex;border-top:1px solid #ccc;font-size:.4rem;text-align:center}.cell-dialog-wrap .cell-dialog-btns .dlg-btn{box-flex:1;-moz-flex:1;flex:1;color:#666;background-color:#fff;padding:0;height:1rem;line-height:1rem;border-right:1px solid #ccc}.cell-dialog-wrap .cell-dialog-btns .dlg-btn:last-child{border-right:none}.cell-dialog-wrap .cell-dialog-btns .dlg-btn.btn-ok{color:#fb3434}.cell-dialog-wrap .cell-dialog{opacity:0}.cell-dialog-wrap .cell-dialog.fadeInScale{transform:scale(.7);opacity:0;transition:all .3s}.cell-dialog-wrap .cell-dialog.slideInRight{transform:translateX(20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInLeft{transform:translateX(-20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInBottom{transform:translateY(20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInTop{transform:translateY(-20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-show{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.cell-dialog-show.pos-top{box-align:start;align-items:flex-start}.cell-dialog-show.pos-right{box-pack:end;justify-content:flex-end}.cell-dialog-show.pos-bottom{box-align:end;align-items:flex-end}.cell-dialog-show.pos-left{box-pack:start;justify-content:flex-start}.cell-dialog-animate,.cell-dialog-animate .cell-dialog{opacity:1}.cell-dialog-animate .cell-dialog.fadeInScale{transform:scale(1);opacity:1}.cell-dialog-animate .cell-dialog.slideInBottom,.cell-dialog-animate .cell-dialog.slideInLeft,.cell-dialog-animate .cell-dialog.slideInRight,.cell-dialog-animate .cell-dialog.slideInTop{transform:translateX(0);opacity:1}");
function movePrevent(e) {
  if (e.preventDefault) {
    e.preventDefault();
  }
}

function closeFn() {
  this.close && this.close();
}

module.exports = Magix.View.extend({
  tmpl: "<div class=\"cell-dialog <%= animated %> <%= elCls %>\" style=\"<%if(width){%>width:<%= width %>;<%}%><%if(height){%>height:<%= height %>;<%}%>\"> <% if(title){ %> <div class=\"cell-dialog-title\"><div class=\"title\"><%! title %></div></div> <% } %> <% if(content){ %> <div class=\"cell-dialog-content\"><%! content %></div> <% } %> <% if(view){ %> <div id=\"dialog_subview_of_<%= ownerid %>\" class=\"cell-dialog-content\" mx-view></div> <% } %> <% if(okBtnMsg || cancelBtnMsg){%> <div class=\"cell-dialog-btns\"> <% if(cancelBtnMsg){%> <div class=\"dlg-btn btn-cancel\" mx-click=\"cancelBtnClick()\"><%! cancelBtnMsg %></div> <% } %> <% if(okBtnMsg){%> <div class=\"dlg-btn btn-ok\" mx-click=\"okBtnClick()\"><%! okBtnMsg %></div> <% } %> </div> <% } %> <% if(closable){ %> <div class=\"cell-dialog-close\" mx-click=\"close()\"></div> <% } %> </div>",
  ctor: function ctor(e) {
    var me = this;
    var options = e.options || {};
    var pos = options.pos;
    if (!options.animated && posAniMap[pos]) {
      options.animated = posAniMap[pos];
    }
    me.$options = $.extend({
      width: '',
      height: '',
      zIndex: '',
      closable: true,
      closeDestroy: false,
      maskClosable: true,
      elCls: '',
      view: '',
      viewOptions: {},
      content: '',
      show: false,
      animated: 'fadeInScale', // fadeInScale slideInRight slideInLeft slideInTop
      title: '',
      preventScroll: true,
      preventType: 'preventDefault', // fixed preventDefault
      autoCloseMs: '',
      pos: '',
      showMask: true,
      okBtnMsg: '',
      cancelBtnMsg: '',
      okBtnCallback: closeFn,
      cancelBtnCallback: closeFn
    }, options);

    me.$options.autoCloseMs = parseInt(me.$options.autoCloseMs) || '';
    me.$el = $('#' + me.id);
    me.autoCloseTimer = null;

    me.fixOptions(me.$options);
    me.$relatedElement = $('#' + me.id);
    me.$relatedElement.addClass('cell-dialog-wrap');
    me.on('destroy', function () {
      $('#' + me.id).remove();
    });
  },
  // 属性的特殊处理，比如width这种px的处理
  fixOptions: function fixOptions(options) {
    if (options.width && /\d$/.test(options.width)) {
      options.width += 'px';
    }
    if (options.height && /\d$/.test(options.height)) {
      options.height += 'px';
    }
  },
  render: function render() {
    var me = this;
    me.$options.ownerid = me.id;
    var pos = me.$options.pos;

    if (pos) {
      me.$el.addClass('pos-' + pos);
    }
    if (!me.$options.showMask) {
      me.$el.addClass('no-mask');
    }

    var html = $.tmpl(me.tmpl, me.$options);
    me.setHTML(me.id, html);

    if (me.$options.view) {
      var vf = Magix.Vframe.get('dialog_subview_of_' + me.id);
      if (vf) {
        vf.mountView(me.$options.view, me.$options.viewOptions);
      }
    }
    // 一些特殊配置的处理
    me.$options.zIndex && me.$relatedElement.css('zIndex', me.$options.zIndex);
    if (me.$options.show) {
      me.open();
    }
    if (me.$options.maskClosable) {
      me.$relatedElement.on('click', function (e) {
        if (!$.contains(me.$relatedElement[0], e.target)) {
          me.close();
        }
      });
    }
  },
  open: function open() {
    var me = this;
    me.$relatedElement.addClass('cell-dialog-show');
    setTimeout(function () {
      me.$relatedElement.addClass('cell-dialog-animate');
    }, 10);
    if (me.$options.preventScroll && me.$options.preventType == 'fixed') {
      $('html').addClass('cell-dialog-hide');
    }
    if (me.$options.preventScroll && me.$options.preventType == 'preventDefault') {
      $('#' + me.id).on('touchmove', movePrevent);
    }
    $('#' + me.id).trigger({
      type: 'open',
      value: ''
    });
    if (me.$options.autoCloseMs) {
      clearTimeout(me.autoCloseTimer);
      me.autoCloseTimer = setTimeout(function () {
        me.close();
      }, me.$options.autoCloseMs);
    }
  },
  close: function close(cb) {
    var me = this;
    me.$relatedElement.removeClass('cell-dialog-animate');
    // 防止点击穿透
    setTimeout(function () {
      if (me.$options.closeDestroy) {
        me.destroy();
      } else {
        me.$relatedElement.removeClass('cell-dialog-show');
      }
      if (me.$options.preventScroll && me.$options.preventType == 'fixed') {
        $('html').removeClass('cell-dialog-hide');
      }
      if (me.$options.preventScroll && me.$options.preventType == 'preventDefault') {
        $('#' + me.id).off('touchmove', movePrevent);
      }
      $('#' + me.id).trigger({
        type: 'close',
        value: ''
      });
    }, 300);
    clearTimeout(me.autoCloseTimer);
    me.autoCloseTimer = null;
  },
  setHtml: function setHtml(html, $el) {
    //修改dialog某处的内容
    $el = $($el);
    if ($el.length < 1) {
      $el = this.$el.find('.cell-dialog-content').eq(0);
    }
    $el.html(html);
  },
  'okBtnClick<click>': function okBtnClickClick(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (this.$options.okBtnCallback) {
      this.$options.okBtnCallback.call(this);
    }
  },
  'cancelBtnClick<click>': function cancelBtnClickClick(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (this.$options.cancelBtnCallback) {
      this.$options.cancelBtnCallback.call(this);
    }
  },
  'close<click>': function closeClick(e) {
    var me = this;
    me.close();
  },
  destroy: function destroy() {
    this.owner.unmountVframe();
  }
}, {
  create: function create(params) {
    var rootId = Magix.config('rootId');
    var owner = params.owner || Magix.Vframe.get(rootId);
    var id = 'cell' + Magix.guid('dlg_');
    var $parent = $(params.parentEl);
    if ($parent.length < 1) {
      $parent = $('body');
    }
    if (params.el) {
      id = params.el;
    } else {
      $parent.append('<div class="cell-dialog-wrap" id="' + id + '"/>');
    }
    var path = this.__moduleid__ || 'cell-dialog';
    owner.mountVframe(id, path, params);
    return $('#' + id);
  }
});

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2g","@font-face{font-family:uxiconfont;src:url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.eot);src:url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.eot#iefix) format(\"embedded-opentype\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.woff) format(\"woff\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.ttf) format(\"truetype\"),url(//assets.alicdn.com/apps/e/brix/fonts/uxiconfont.svg#uxiconfont) format(\"svg\")}.iconfont{font-family:uxiconfont;font-size:16px;font-style:normal}.backtop{position:fixed;bottom:50px;overflow:hidden;right:0;z-index:200;text-align:center;width:44px;height:50px;filter:alpha(opacity=70);opacity:.7}.backtop .trigger{display:block;overflow:hidden;border:1px solid #c6c6c6;margin-top:-2px;background:#bbbdc1}.backtop .trigger:hover{background:#aeaeae}.backtop .trigger span{display:block;width:40px;height:48px;line-height:48px;color:#fff;font-size:16px;border:1px solid #cbcbcb}.backtop .totop-btn{display:none}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"backtop\"><a href=\"#\" class=\"trigger totop-btn\" title=\"回到顶部\"><span class=\"iconfont\">&#404;</span></a></div>","subs":[]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Node: null
        });
    },
    initBackTop: function initBackTop() {
        var S = this.opt.S,
            Node = this.opt.Node;

        function BackTop() {
            var win = S.one(window);
            this.holder = S.one('.backtop');
            this.topBtn = S.one('.totop-btn', this.holder);

            this._detect();
            this.events();
        }
        BackTop.prototype._detect = function () {
            var self = this;
            var win = S.one(window);
            var top = win.scrollTop();
            if (top > 0) {
                self.topBtn.css('display', 'block');
                if (S.UA.ie && S.UA.ie < 7) {
                    var t = S.DOM.viewportHeight() + top - 45 - 125;
                    self.holder.css('top', t);
                }
            } else {
                self.topBtn.hide();
            }
        };
        BackTop.prototype.events = function () {
            var win = S.one(window);
            var self = this;
            win.on('scroll', function () {
                self._detect();
            });
            self.topBtn.on('click', function (e) {
                e.preventDefault();
                var trigger = Node(e.currentTarget);
                S.one(window).animate({
                    scrollTop: 0
                }, {
                    duration: 0.5,
                    easing: 'easeOut'
                });
            });
        };
        new BackTop();
    },
    render: function render() {
        var self = this;
        KISSY.use("node", function (S, Node) {
            self.opt.Node = Node;
            self.updater.set({}).digest();
            self.initBackTop();
        });
    }
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2f",".ManagerHotSale{margin-top:50px;border:1px solid #ededed}.ManagerHotSale .subTitle{position:relative;height:40px;background:#f2f2f2;border-bottom:1px solid #ededed}.ManagerHotSale .subTitle em{color:#f85231;font-size:14px;line-height:40px;margin-left:8px;font-weight:700}.ManagerHotSale .subTitle .p4p-rec-list{position:absolute;top:12px;margin:0;list-style:none;left:90px;height:20px;overflow:hidden;width:800px}.ManagerHotSale .subTitle .p4p-rec-list li{float:left}.ManagerHotSale .subTitle .p4p-rec-list li a{display:block;padding:0 10px;text-decoration:underline;color:#666}.ManagerHotSale .subTitle .p4p-rec-list li a:hover{color:#f40}.ManagerHotSale .subTitle .p4p-apply{text-align:left;position:absolute;right:10px;bottom:9px;width:100px;color:#666}.ManagerHotSale .item-wraper{height:270px;background:#fff;padding:14px 0 10px 17px}.ManagerHotSale .item-wraper .item a:hover{text-decoration:none}.ManagerHotSale .item-wraper .item{float:left;font-size:12px;margin-right:15px;width:178px;border:1px solid #f2f2f2}.ManagerHotSale .item-wraper .item.hover,.ManagerHotSale .item-wraper .item:hover{border-color:#f85300}.ManagerHotSale .item-wraper .item .imgContainer{height:178px;width:178px;overflow:hidden}.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:178px;height:178px;display:table-cell;text-align:center;vertical-align:middle}.ManagerHotSale .item-wraper .item .imgContainer .imgLink img{vertical-align:middle;max-width:none}.ManagerHotSale .item-wraper .item .titleWrap{padding-left:5px;overflow:hidden}.ManagerHotSale .item-wraper .item .icon-tmall{background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/service.png) -83px -129px no-repeat;font-size:0;float:left;width:16px;height:16px;margin-top:3px;margin-right:4px;display:inline-block}.ManagerHotSale .item-wraper .item .title{width:142px;height:30px;line-height:27px;float:left;overflow:hidden;color:#000;display:block}.ManagerHotSale .item-wraper .item .title .hl{color:#ef470f}.ManagerHotSale .item-wraper .item .title:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info{height:45px;padding:5px;line-height:30px}.ManagerHotSale .item-wraper .item .info .icon{width:27px;height:14px;background:url(//img.alicdn.com/tps/i2/T1RJKwFqRdXXXM4v6c-27-14.png) no-repeat;float:right;margin:7px 4px 0 0}.ManagerHotSale .item-wraper .item .info .price{font-size:16px;line-height:16px;margin-top:4px;color:#f40;font-family:arial,verdana,sans-serif}.ManagerHotSale .item-wraper .item .info .price strong{font-weight:700}.ManagerHotSale .item-wraper .item .info .price strong:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info .price .origin-price{text-decoration:line-through;color:#aaa;padding-left:4px;font-size:12px;font-weight:400}.ManagerHotSale .item-wraper .item .info .sales{float:left;line-height:20px;margin-top:4px;color:#333}.ManagerHotSale .item-wraper .item .info .sales strong{font-weight:400}.ManagerHotSale .item-wraper .item .info .sales:hover{text-decoration:underline!important}.ManagerHotSale .item-wraper .item .info .title{color:#666}.ManagerHotSale .item-wraper .item .info #dsr-info-hover .dsr-info-list{display:block}.ManagerHotSale .item-wraper .item .info .dsr-info{display:block;position:relative;z-index:2;float:right;line-height:15px;width:95px;height:18px;margin-top:6px}.ManagerHotSale .item-wraper .item .info .dsr-info .active{text-decoration:none;border:1px solid #d9d9d9;height:16px;line-height:16px;padding-left:3px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-num{margin-left:5px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-tgr{position:relative;display:block;color:gray;cursor:default;outline:0;text-decoration:none}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-tgr .dropdown-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -129px -285px no-repeat}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{position:absolute;display:none;top:15px;width:93px;left:0;color:gray;list-style:none;background-color:#fff;border:1px solid #ddd;border-radius:0 0 3px 3px;margin-top:-15px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .morethan{color:#b30f00}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .listup-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -146px -285px no-repeat}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list .lessthan{color:#20730f}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list span{display:block;height:18px;padding:2px 5px;font-weight:400;white-space:nowrap}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list span b{font-weight:400;padding-left:5px}@media screen and (min-width:1190px) and (max-width:1349px){.ManagerHotSale .item-wraper{height:305px}.ManagerHotSale .item-wraper .item{width:218px;margin-right:13px}.ManagerHotSale .item-wraper .item .imgContainer,.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:218px;height:218px}.ManagerHotSale .item-wraper .item .title{width:181px}.ManagerHotSale .item-wraper .item .info .dsr-info{width:105px}.ManagerHotSale .subTitle .p4p-rec-list{width:990px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:103px}}@media screen and (min-width:1350px){.ManagerHotSale .item-wraper{height:345px}.ManagerHotSale .item-wraper .item{width:248px}.ManagerHotSale .item-wraper .item .imgContainer,.ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:248px;height:248px}.ManagerHotSale .item-wraper .item .title{width:211px}.ManagerHotSale .item-wraper .item .info .dsr-info{width:115px}.ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:113px}.ManagerHotSale .subTitle .p4p-rec-list{width:1000px}}#body1190 .ManagerHotSale .item-wraper{height:305px}#body1190 .ManagerHotSale .item-wraper .item .info .dsr-info{width:105px}#body1190 .ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:103px}#body1190 .ManagerHotSale .subTitle .p4p-rec-list{width:990px}#body1190 .ManagerHotSale .item-wraper .item{width:218px;margin-right:13px}#body1190 .ManagerHotSale .item-wraper .item .imgContainer,#body1190 .ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:218px;height:218px}#body1190 .ManagerHotSale .item-wraper .item .title{width:181px}#body1350 .ManagerHotSale .item-wraper{height:345px}#body1350 .ManagerHotSale .item-wraper .item .info .dsr-info{width:115px}#body1350 .ManagerHotSale .item-wraper .item .info .dsr-info .dsr-info-list{width:113px}#body1350 .ManagerHotSale .subTitle .p4p-rec-list{width:1000px}#body1350 .ManagerHotSale .item-wraper .item{width:248px}#body1350 .ManagerHotSale .item-wraper .item .imgContainer,#body1350 .ManagerHotSale .item-wraper .item .imgContainer .imgLink{width:248px;height:248px}#body1350 .ManagerHotSale .item-wraper .item .title{width:211px}");

var Util = __webpack_require__(0);

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"ManagerHotSale\"><div class=\"subTitle\"><em>掌柜热卖</em><div mx-guid=\"g0\u001f\" id=\"J_p4plink\" data-url=\"<%= $$.data.p4pTextLink%>\"><ul mx-guid=\"g1\u001f\" class=\"p4p-rec-list J_proxy_textlink\" data-linkpid=\"<%= $$.data.linkpid%>\"></ul></div><a href=\"http://zhitongche.taobao.com\" target=\"_blank\" class=\"p4p-apply\">我也要出现在这里</a></div><div mx-guid=\"g2\u001f\" class=\"item-wraper\" data-spm=\"3223322\">3\u001d</div></div>","subs":[{"keys":["data"],"path":"div[mx-guid=\"g0\u001f\"]","attr":"data-url=\"<%= $$.data.p4pTextLink%>\"","attrs":[{"n":"data-url"}]},{"keys":["data"],"path":"ul[mx-guid=\"g1\u001f\"]","attr":"data-linkpid=\"<%= $$.data.linkpid%>\"","attrs":[{"n":"data-linkpid"}]},{"keys":["entity"],"path":"div[mx-guid=\"g2\u001f\"]","tmpl":"<%$$.entity.forEach(function(a){%><div class=\"item\"><a href=\"<%= a.eurl%>\" class=\"imgLink\" target=\"_blank\"><div class=\"imgContainer\"><span class=\"imgLink\"><img data-ks-lazyload=\"<%= a.imgUrl%>_220x220.jpg\" src=\"//g.alicdn.com/s.gif\"></span></div><p class=\"titleWrap\"><%if(a.ismall=='1'){%><span class=\"icon-tmall\"></span><%}%><span class=\"title\" title=\"<%= a.title%>\"><%= a.title%></span></p><div class=\"info\"><p class=\"price\"><%if(a.promoPrice&&a.promoPrice!=''){%> &yen;<strong><%= a.promoPrice%></strong><span class=\"origin-price\">&yen;<%= a.price%></span><%}else{%><span>&yen;<strong><%= a.price%></strong></span><%}%></p><span class=\"sales\">销量：<%= a.sellCount%></span><div class=\"dsr-info\"><span class=\"active dsr-info-tgr\"><span class=\"icon-btn-dsr\">如实描述:</span><span class=\"dsr-info-num\"><%= a.dsrDescribe%></span><span class=\"dropdown-tgr-arrow\"></span></span><ul class=\"dsr-info-list\"><%if(a.dsrDescribeGap=='0'){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap==''){%><li><span class=\"morethan\">如实描述:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap&&a.dsrDescribeGap.indexOf('-')==-1){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrServiceGap=='0'){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap==''){%><li><span class=\"morethan\">服务态度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap&&a.dsrServiceGap.indexOf('-')==-1){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrDeliverGap=='0'){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap==''){%><li><span class=\"morethan\">发货速度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap&&a.dsrDeliverGap.indexOf('-')==-1){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}%></ul></div></div></a></div><%})%>","s":"3\u001d"}]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            DOM: null,
            Node: null,
            DataLazyLoad: null
        });
    },
    initShopHotsell: function initShopHotsell() {
        var DataLazyLoad = this.opt.DataLazyLoad,
            S = this.opt.S,
            DOM = this.opt.DOM,
            Node = this.opt.Node;

        function ShopHotsell() {
            this.init();
            this.events();
        }
        ShopHotsell.prototype.init = function () {
            var self = this;
            var ieVersion = parseInt(KISSY.UA.ie, 10);
            var resultContainer = S.one('.ManagerHotSale');
            var link = S.all('a', resultContainer);

            self.reg = /_\d{2,3}x\d{2,3}\.(jpg|gif)$/;
            self.resultContainer = resultContainer;

            // self.adjustSize();

            // 处理url
            S.each(link, function (item) {
                item.href = item.href.replace(/&amp;/g, '&');
            });

            //搜索词高亮处理
            if (window._SEARCHKEYWORDS && window._SEARCHKEYWORDS != "") {
                var keyword = decodeURIComponent(window._SEARCHKEYWORDS);
                /*高亮处理*/
                self._highLightKeyWords(resultContainer, keyword);
            }
            setTimeout(function () {
                self.getText();
            }, 800);

            // lazyload
            var lazyload = new DataLazyLoad({
                container: resultContainer,
                placeholder: "//g.alicdn.com/s.gif"
            });
            if (window._WEBP && lazyload._images) {
                S.each(lazyload._images, function (images) {
                    images = S.one(images);
                    if (images.attr("data-ks-lazyload").indexOf("_.webp") < 0) {
                        images.attr("data-ks-lazyload", images.attr("data-ks-lazyload") + "_.webp");
                    }
                });
            }
        };
        /*
        * 搜索文字链
        * */
        ShopHotsell.prototype.getText = function () {
            var self = this;
            var J_p4plink = S.one('#J_p4plink', self.resultContainer),
                dataUrl = J_p4plink.attr('data-url'),
                J_linkUl = J_p4plink.one('ul');
            self.requestLink(dataUrl, function (e) {
                var list = e.data.data1 || [];
                var itemList = [];
                S.each(list, function (thisitem, idx) {
                    var li = DOM.create('<li>');
                    if (idx > 15) return; //当idx大于10 的时候return只取10个词防止出现溢出的情况
                    var a = DOM.create('<a>', {
                        href: thisitem.clickUrl.replace(/&amp;/g, '&'), //new XTemplate(href).render(App.getData())
                        text: thisitem.title,
                        target: '_blank'
                    });
                    DOM.append(a, li);
                    itemList.push(li);
                });
                DOM.append(itemList, J_linkUl);
            });
        };
        ShopHotsell.prototype.requestLink = function (url, cb) {
            if (url == '') return;

            Util.sync(url, {}, cb, function (err) {});

            // S.io({
            //     url: url,
            //     dataType: 'jsonp',
            //     jsonp: 'cb',
            //     data: '',
            //     success: function (d) {
            //         if (cb && typeof cb == 'function') {
            //             cb(d);
            //         }
            //     },
            //     error: function () {
            //         //S.Event.fire(self, EVENT_ERROR);
            //     }
            // });
        };
        ShopHotsell.prototype.events = function () {
            var self = this;
            var resultContainer = self.resultContainer;
            // S.one(window).on('resize',function(){
            //     self.adjustSize(); 
            // }); 

            resultContainer.delegate('mouseover mouseout', '.dsr-info-tgr', function (e) {
                var dsrInfo = Node(e.currentTarget).parent();
                if (e.type == 'mouseover') {
                    dsrInfo.attr('id', 'dsr-info-hover');
                } else {
                    dsrInfo.attr('id', '');
                }
            });
            resultContainer.delegate('mouseover mouseout', '.dsr-info-list', function (e) {
                var dsrInfo = Node(e.currentTarget).parent();
                if (e.type == 'mouseover') {
                    dsrInfo.attr('id', 'dsr-info-hover');
                } else {
                    dsrInfo.attr('id', '');
                }
            });
        };
        /*
        * 判断屏幕宽度
        * @return num
        * */
        ShopHotsell.prototype.getBrowserWidth = function () {
            if (window.innerWidth) {
                return window.innerWidth;
            } else if (document.documentElement && document.documentElement.clientWidth != 0) {
                return document.documentElement.clientWidth;
            } else if (document.body) {
                return document.body.clientWidth;
            }
            return 0;
        };
        /*
        * 适应不同屏幕
        * */
        ShopHotsell.prototype.adjustSize = function () {
            var self = this,
                width = self.getBrowserWidth(),
                ct = S.one('.ManagerHotSale'),
                targets = S.all('img', ct);
            if (width >= 1350) {
                self.replaceImg(targets, '_250x250.jpg');
            } else if (width < 1349 && width >= 1190) {
                self.replaceImg(targets, '_220x220.jpg');
            } else {
                self.replaceImg(targets, '_190x190.jpg');
            }
        };
        /*
        * 替换图片后缀
        *  @param target DOM Object
        *  @param size   String 
        *  @return null
        * */
        ShopHotsell.prototype.replaceImg = function (target, size) {
            var self = this;
            for (var i = 0, len = target.length; i < len; i++) {
                var oldSrc = Node(target[i]).attr('src'),
                    newSrc = oldSrc.replace(self.reg, size);
                Node(target[i]).attr('src', newSrc);
            }
        };
        /*
        * 关键词高亮处理
        * @params wrapper DOM Object
        * */
        ShopHotsell.prototype._highLightKeyWords = function (wrapper, keyword) {
            var titleList = wrapper.all('.title');
            var i = 0,
                len = titleList.length;
            for (; i < len; i++) {
                titleList[i].innerHTML = this._replacement(titleList[i].innerHTML, keyword);
            }
        };
        /*
        *  替换关键词
        *  @params string String
        *  @return string
        * */
        ShopHotsell.prototype._replacement = function (string, keyword) {
            return string.replace(RegExp('(' + keyword.replace(/\W/g, function (e) {
                return '\\u' + ('000' + e.charCodeAt(0).toString(16)).slice(-4);
            }) + ')'), '<font class="hl">$1</font>');
        };
        new ShopHotsell();
    },
    render: function render() {
        var self = this;
        var root = window.root;

        KISSY.use("dom, node, kg/datalazyload/2.0.0/", function (S, DOM, Node, DataLazyLoad) {
            self.opt.Node = Node;
            self.opt.DataLazyLoad = DataLazyLoad;
            self.opt.DOM = DOM;

            // Util.sync('//odin.re.taobao.com/search_tbuad', {
            //     catid: root.url.catid,
            //     frcatid: root.url.frcatid,
            //     keyword: root.url.keyword,
            //     from: root.compExt.mosic,
            //     ac: root.cookie.cna,
            //     ip: root.env.ip,
            //     wangwangid: root.cookie.tracknick,
            //     offset: root.url.offset,
            //     count: root.compExt.count,
            //     pid: root.compExt.pid,
            //     refpid: root.url.refpid,
            //     buckid: root.env.buckid,
            //     p4pTags: root.compExt.p4pTags,
            //     clk1: root.url.clk1,
            //     elemtid: root.url.elemtid,
            //     propertyid: root.url.propertyid,
            //     loc: root.url.loc,
            //     gprice: root.url.gprice,
            //     ismall: root.url.ismall,
            //     page: root.url.page,
            //     creativeid: root.url.refpos,
            //     debug: root.url.debug
            // }, 

            //  data-url="//odin.re.taobao.com/search_tbuad?catid=<%= root.url.catid %>&frcatid=<%= root.url.frcatid %>&keyword=<%= root.url.keyword %>&from=<%= root.compExt.mosic %>&ac=<%= root.cookie.cna %>&ip=<%= root.env.ip %>&wangwangid=<%= root.cookie.tracknick %>&offset=<%= root.url.offset %>&count=<%= root.compExt.count %>&pid=<%= root.compExt.pid %>&refpid=<%= root.url.refpid %>&buckid=<%= root.env.buckid %>&p4pTags=<%= root.compExt.p4pTags %>&clk1=<%= root.url.clk1 %>&elemtid=<%= root.url.elemtid %>&propertyid=<%= root.url.propertyid %>&loc=<%= root.url.loc %>&gprice=<%= root.url.gprice %>&ismall=<%= root.url.ismall %>&page=<%= root.url.page %>&creativeid=<%= root.url.refpos %>&debug=<%= root.url.debug %>" 

            Util.sync(self.opt.url, {}, function (json) {
                self.updater.set({
                    // root: window.root,
                    data: {
                        linkpid: self.opt.linkpid,
                        p4pTextLink: self.opt.p4ptextlink
                        //odin.re.taobao.com/search_stext?catid=<%= root.url.catid %>&frcatid=<%= root.url.frcatid %>&keyword=<%= root.url.keyword %>&tlpid=<%= root.compExt.tlpid %>&refpid=<%= root.url.refpid %>&debug=<%= root.url.debug %>
                    },
                    entity: json.data.data1
                }).digest();

                self.initShopHotsell();
            }, function (err) {});
        });
    }
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2d",".searchResult{margin-top:10px}.searchResult .views{overflow:hidden}.searchResult .view{width:1010px;overflow:hidden;padding-bottom:30px}.searchResult .view .item{float:left;margin:0 12px 20px 0;width:188px;border:1px solid #eee;background:#fff}.searchResult .view .item a{color:#000}.searchResult .view .item.hover,.searchResult .view .item:hover{border-color:#f85300}.searchResult .view .item .imgContainer{width:188px;height:188px;overflow:hidden}.searchResult .view .item .imgContainer .imgLink{width:188px;height:188px;text-align:center;display:table-cell;vertical-align:middle}.searchResult .view .item .imgContainer .imgLink img{vertical-align:middle}.searchResult .view .item .info{padding:10px}.searchResult .view .item .info .price{font-size:16px;line-height:16px;overflow:hidden;margin-top:4px}.searchResult .view .item .info .price .pricedetail{font-family:arial,verdana,sans-serif}.searchResult .view .item .info .price span{float:left;color:#f40}.searchResult .view .item .info .price span:hover{text-decoration:underline!important}.searchResult .view .item .info .price strong{font-weight:700}.searchResult .view .item .info .price .origin-price{text-decoration:line-through;color:#aaa;padding-left:4px;font-size:12px;font-weight:400}.searchResult .view .item .info .price .postalicon{float:left;width:27px;height:14px;color:#fff;font-size:12px;margin-left:4px;text-align:center;vertical-align:middle;background:#f85300}.searchResult .view .item .info .price .discountNum{font-family:arial;float:right;width:47px;height:14px;text-align:center;vertical-align:middle;border:1px solid #e5d9ad;font-size:12px;background:#faffe1;color:#666;line-height:14px}.searchResult .view .item .info .title{width:158px;height:34px;overflow:hidden;color:#000;margin-top:5px;display:block}.searchResult .view .item .info .title .hl{color:#ef470f}.searchResult .view .item .info .title:hover{text-decoration:underline!important}.searchResult .view .item .info .shopName{overflow:hidden;margin-top:5px}.searchResult .view .item .info .shopName .shopNick{float:left;display:block;overflow:hidden;width:100px;white-space:nowrap;color:#888;text-decoration:underline}.searchResult .view .item .info .shopName .shopNick:hover{text-decoration:underline}.searchResult .view .item .info .shopName .payNum{float:right;width:68px;overflow:hidden;text-align:right;white-space:nowrap;display:block;color:#888;text-overflow:ellipsis}.searchResult .view .item .info .moreInfo{height:23px;margin-top:5px}.searchResult .view .item .info .moreInfo .icon{float:left}.searchResult .view .item .info .moreInfo .icon span{background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/service.png) no-repeat;font-size:0}.searchResult .view .item .info .moreInfo .icon .icon-tmall{width:16px;height:16px;margin-top:5px;margin-right:4px;background-position:-83px -129px;display:inline-block}.searchResult .view .item .info .moreInfo .icon .icon-new{width:30px;height:30px;margin-top:5px;margin-right:4px;background-position:-97px -31px;display:inline-block}.searchResult .view .item .info .moreInfo .icon .icon-golden{width:16px;height:16px;margin-top:5px;margin-right:4px;background-position:-188px -57px;display:inline-block}.searchResult .view .item .info .moreInfo .icon .icon-ju{width:16px;height:16px;margin-top:5px;margin-right:4px;background-position:-188px -5px;display:inline-block}.searchResult .view .item .info #dsr-info-hover .dsr-info-list{display:block}.searchResult .view .item .info .dsr-info{display:block;position:relative;float:right;line-height:15px;width:105px;height:18px;margin-top:6px}.searchResult .view .item .info .dsr-info .active{text-decoration:none;border:1px solid #d9d9d9;height:16px;line-height:16px;padding-left:3px}.searchResult .view .item .info .dsr-info .dsr-info-num{margin-left:5px}.searchResult .view .item .info .dsr-info .dsr-info-tgr{position:relative;display:block;color:gray;cursor:default;outline:0;text-decoration:none}.searchResult .view .item .info .dsr-info .dsr-info-tgr .dropdown-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -129px -285px no-repeat}.searchResult .view .item .info .dsr-info .dsr-info-list{position:absolute;display:none;top:15px;width:103px;left:0;color:gray;list-style:none;background-color:#fff;border:1px solid #ddd;border-radius:0 0 3px 3px;margin-top:-15px}.searchResult .view .item .info .dsr-info .dsr-info-list .morethan{color:#b30f00;zoom:1}.searchResult .view .item .info .dsr-info .dsr-info-list .listup-tgr-arrow{position:absolute;top:6px;right:3px;width:7px;display:inline-block;height:4px;font-size:0;padding:0;background:url(//g.alicdn.com/tb/bsrp/0.14.1/assets/images/normal/btn.png) -146px -285px no-repeat}.searchResult .view .item .info .dsr-info .dsr-info-list .lessthan{color:#20730f}.searchResult .view .item .info .dsr-info .dsr-info-list span{display:block;height:18px;padding:2px 5px;font-weight:400;white-space:nowrap}.searchResult .view .item .info .dsr-info .dsr-info-list span b{font-weight:400;padding-left:5px}@media screen and (min-width:1190px) and (max-width:1349px){.searchResult .view{width:1215px}.searchResult .view .item{width:218px;margin:0 22px 20px 0}.searchResult .view .item .imgContainer,.searchResult .view .item .imgContainer .imgLink{width:218px;height:218px}.searchResult .view .item .info .title{width:197px}.searchResult .view .item .info .shopName .payNum{width:85px}}@media screen and (min-width:1350px){.searchResult .view{width:1375px}.searchResult .view .item{width:250px;margin:0 22px 22px 0}.searchResult .view .item .imgContainer,.searchResult .view .item .imgContainer .imgLink{width:250px;height:250px}.searchResult .view .item .info .title{width:227px;height:20px}.searchResult .view .item .info .shopName .payNum{width:95px}}#body1190 .searchResult .view{width:1215px}#body1190 .searchResult .view .item{width:218px;margin:0 22px 20px 0}#body1190 .searchResult .view .item .imgContainer,#body1190 .searchResult .view .item .imgContainer .imgLink{width:218px;height:218px}#body1190 .searchResult .view .item .info .title{width:197px}#body1190 .searchResult .view .item .info .shopName .payNum{width:85px}#body1350 .searchResult .view{width:1375px}#body1350 .searchResult .view .item{width:250px;margin:0 22px 22px 0}#body1350 .searchResult .view .item .imgContainer,#body1350 .searchResult .view .item .imgContainer .imgLink{width:250px;height:250px}#body1350 .searchResult .view .item .info .title{width:227px;height:20px}#body1350 .searchResult .view .item .info .shopName .payNum{width:95px}.page-tmall .searchResult .view .item:hover{border-color:#c40000}.page-tmall .searchResult .view .item .info .price span{color:#c40000}.page-tmall .searchResult .view .item .info .price .postalicon{background-color:#c40000;color:#fff}.page-tmall .searchResult .view .item .info .title .hl{color:#c40000}");
var Util = __webpack_require__(0);
// var searchData = require('./mock.js')

module.exports = Magix.View.extend({
  tmpl: {"html":"<div id=\"searchResult\" class=\"searchResult\"><div mx-guid=\"g0\u001f\" id=\"ItemWrapper\" class=\"view\">1\u001d</div></div>","subs":[{"keys":["entity","webp"],"path":"div[mx-guid=\"g0\u001f\"]","tmpl":"<%$$.entity.forEach(function(a){%><div class=\"item\"><a target=\"_blank\" href=\"<%= a.eurl%>\"><div class=\"imgContainer\"><span class=\"imgLink\"><img data-ks-lazyload=\"<%= a.imgUrl%>_220x220.jpg<%= $$.webp%>\" src=\"//g.alicdn.com/s.gif\"></span></div><div class=\"info\"><p class=\"price\"><span class=\"pricedetail\">&yen;<strong><%if(a.promoPrice&&a.promoPrice!=''){%> <%= a.promoPrice%> <%}else{%> <%= a.price%> <%}%></strong></span><%if(a.sellerPayPostfee){%><span class=\"postalicon\">包邮</span><%}%></p><span class=\"title\" title=\"<%= a.title%>\"><%= a.title%></span><p class=\"shopName\"><span class=\"shopNick\"><%= a.wangwangId%></span><span class=\"payNum\"><%= a.sellCount%>人付款</span></p><div class=\"moreInfo\"><%if(a.ismall=='1'){%><span class=\"icon\"><span class=\"icon-tmall\"></span></span><%}if(a.spGoldMedal=='1'&&a.ismall=='0'){%><span class=\"icon\"><span class=\"icon-golden\"></span></span><%}%><div class=\"dsr-info\"><span class=\"active dsr-info-tgr\"><span class=\"icon-btn-dsr\">如实描述:</span><span class=\"dsr-info-num\"><%= a.dsrDescribe%></span><span class=\"dropdown-tgr-arrow\"></span></span><ul class=\"dsr-info-list\"><%if(a.dsrDescribeGap=='0'){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap==''){%><li><span class=\"morethan\">如实描述:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDescribeGap&&a.dsrDescribeGap.indexOf('-')==-1){%><li><span class=\"morethan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">如实描述:<b><%= a.dsrDescribe%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrServiceGap=='0'){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap==''){%><li><span class=\"morethan\">服务态度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrServiceGap&&a.dsrServiceGap.indexOf('-')==-1){%><li><span class=\"morethan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">服务态度:<b><%= a.dsrService%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}if(a.dsrDeliverGap=='0'){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap==''){%><li><span class=\"morethan\">发货速度:<b>---</b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{if(a.dsrDeliverGap&&a.dsrDeliverGap.indexOf('-')==-1){%><li><span class=\"morethan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}else{%><li><span class=\"lessthan\">发货速度:<b><%= a.dsrDeliver%></b></span><span class=\"listup-tgr-arrow\"></span></li><%}}}%></ul></div></div></div></a></div><%})%>","s":"1\u001d"}]},
  ctor: function ctor(opt) {
    this.opt = $.extend(true, opt, {
      S: KISSY,
      Node: null,
      DataLazyLoad: null
    });
  },
  initSearchResult: function initSearchResult() {
    var DataLazyLoad = this.opt.DataLazyLoad,
        S = this.opt.S,
        Node = this.opt.Node;

    function SearchResult() {
      this.init();
      this.events();
    }
    SearchResult.prototype.init = function () {
      var self = this;
      var el = S.one('#searchResult');
      var ieVersion = parseInt(KISSY.UA.ie, 10);
      var resultContainer = S.all('.view');
      var link = S.all('a', resultContainer);

      self.reg = /_\d{2,3}x\d{2,3}\.(jpg|gif)$/;
      self.el = el;
      self.resultContainer = resultContainer;

      // self.adjustSize();

      // 处理url
      S.each(link, function (item) {
        item.href = item.href.replace(/&amp;/g, '&');
      });

      //搜索词高亮处理
      if (window._SEARCHKEYWORDS && window._SEARCHKEYWORDS != "") {
        var keyword = decodeURIComponent(window._SEARCHKEYWORDS);
        /*高亮处理*/
        self._highLightKeyWords(resultContainer, keyword);
      }

      // lazyload
      var lazyload = new DataLazyLoad({
        container: el,
        placeholder: "//g.alicdn.com/s.gif"
      });
      // if (window._WEBP && lazyload._images) {
      //   S.each(lazyload._images, function (images) {
      //     images = S.one(images);
      //     if (images.attr("data-ks-lazyload").indexOf("_.webp") < 0) {
      //       images.attr("data-ks-lazyload", images.attr("data-ks-lazyload") + "_.webp")
      //     }
      //   })
      // }
    };
    SearchResult.prototype.events = function () {
      var self = this;
      var resultContainer = self.resultContainer;
      // S.one(window).on('resize',function(){
      //     self.adjustSize(); 
      // }); 

      resultContainer.delegate('mouseover mouseout', '.dsr-info-tgr', function (e) {
        var dsrInfo = Node(e.currentTarget).parent();
        if (e.type == 'mouseover') {
          dsrInfo.attr('id', 'dsr-info-hover');
        } else {
          dsrInfo.attr('id', '');
        }
      });
      resultContainer.delegate('mouseover mouseout', '.dsr-info-list', function (e) {
        var dsrInfo = Node(e.currentTarget).parent();
        if (e.type == 'mouseover') {
          dsrInfo.attr('id', 'dsr-info-hover');
        } else {
          dsrInfo.attr('id', '');
        }
      });
    };
    /*
     * 判断屏幕宽度
     * @return num
     * */
    SearchResult.prototype.getBrowserWidth = function () {
      if (window.innerWidth) {
        return window.innerWidth;
      } else if (document.documentElement && document.documentElement.clientWidth != 0) {
        return document.documentElement.clientWidth;
      } else if (document.body) {
        return document.body.clientWidth;
      }
      return 0;
    };
    /*
     * 适应不同屏幕
     * */
    SearchResult.prototype.adjustSize = function () {
      var self = this,
          width = self.getBrowserWidth(),
          ct = S.one('#ItemWrapper'),
          targets = S.all('img', ct);
      if (width >= 1350) {
        self.replaceImg(targets, '_250x250.jpg');
      } else if (width < 1349 && width >= 1190) {
        self.replaceImg(targets, '_220x220.jpg');
      } else {
        self.replaceImg(targets, '_190x190.jpg');
      }
    };
    /*
     * 替换图片后缀
     *  @param target DOM Object
     *  @param size   String 
     *  @return null
     * */
    SearchResult.prototype.replaceImg = function (target, size) {
      var self = this;
      for (var i = 0, len = target.length; i < len; i++) {
        var oldSrc = Node(target[i]).attr('src'),
            newSrc = oldSrc.replace(self.reg, size);
        Node(target[i]).attr('src', newSrc);
      }
    };
    /*
     * 关键词高亮处理
     * @params wrapper DOM Object
     * */
    SearchResult.prototype._highLightKeyWords = function (wrapper, keyword) {
      var titleList = wrapper.all('.title');
      var i = 0,
          len = titleList.length;
      for (; i < len; i++) {
        titleList[i].innerHTML = this._replacement(titleList[i].innerHTML, keyword);
      }
    };
    /*
     *  替换关键词
     *  @params string String
     *  @return string
     * */
    SearchResult.prototype._replacement = function (string, keyword) {
      return string.replace(RegExp('(' + keyword.replace(/\W/g, function (e) {
        return '\\u' + ('000' + e.charCodeAt(0).toString(16)).slice(-4);
      }) + ')'), '<font class="hl">$1</font>');
    };
    new SearchResult();
  },

  render: function render() {
    var self = this;

    var mtopdata = self.opt.mtopdata;
    mtopdata = Util.parseParams(mtopdata);
    Util.mtop('mtop.alimama.union.sem.landing.pc.items', mtopdata, function (error, data) {
      KISSY.use("node, kg/datalazyload/2.0.0/", function (S, Node, DataLazyLoad) {
        self.opt.Node = Node;
        self.opt.DataLazyLoad = DataLazyLoad;
        self.updater.set({
          entity: data.mainItems,
          webp: window._WEBP ? '_.webp' : ''
        }).digest();

        self.initSearchResult();
      });
    });
  }
});

/***/ }),
/* 5 */
/***/ (function(module, exports) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2b","@font-face{font-family:sem_icf;src:url(//at.alicdn.com/t/font_1436352478_7451568.eot);src:url(//at.alicdn.com/t/font_1436352478_7451568.eot#iefix) format(\"embedded-opentype\"),url(//at.alicdn.com/t/font_1436352478_7451568.woff) format(\"woff\"),url(//at.alicdn.com/t/font_1436352478_7451568.ttf) format(\"truetype\"),url(//at.alicdn.com/t/font_1436352478_7451568.svg#iconfont) format(\"svg\")}.option_filter{background:#fff;border:1px solid #e8e8e8;color:#747474}.option_filter a{color:#333}.option_filter a:hover{text-decoration:none;color:#ef470f}.option_filter .from,.option_filter .others,.option_filter .price_area{float:left;padding:0 20px;border-right:1px solid #e8e8e8;cursor:pointer;line-height:38px}.option_filter .from.on,.option_filter .others.on,.option_filter .price_area.on{background:#f5f5f5}.option_filter .default{border-left:1px solid #e8e8e8}.option_filter .price_area{padding:0 10px;border:none}.option_filter .price_area .shadow{line-height:38px}.option_filter .price_area .shadow input{width:42px;padding:1px 1px 1px 3px;height:20px;border:1px solid #ccc;color:#777}.option_filter .price_area .shadow span{padding:0 2px;color:#777}.option_filter .price_area .shadow .confirm{display:none}.option_filter .price_area.out .shadow{position:relative;margin-left:-10px;margin-right:-70px;padding-left:10px;width:220px;-webkit-box-shadow:1px 1px 6px #aaa;box-shadow:1px 1px 6px #aaa;background:#fff;z-index:10}.option_filter .price_area.out .shadow .confirm{display:inline-block;margin-left:12px;padding:0 10px;line-height:24px;border-radius:3px;background:#ff4200;color:#fff}.option_filter .from{padding:0 10px 0 5px;height:38px;border-right:none;position:relative}.option_filter .from .trigger{display:block;margin-top:7px;padding-left:4px;height:22px;line-height:22px;border:1px solid #ccc}.option_filter .from .trigger span{float:left}.option_filter .from .trigger i{float:right;margin-left:4px;padding:0 2px;border-left:1px solid #ccc;background:#f5f5f5;font-style:normal;font-family:sem_icf}.option_filter .from .trigger i:after{content:\"\\e601\"}.option_filter .from .content{position:absolute;margin-top:-1px;padding:0 10px;width:340px;line-height:24px;border:1px solid #ccc;background-color:#fff;display:none}.option_filter .from:hover .content{display:block}.option_filter .from .content li{padding:5px 0;border-top:1px dashed #ccc}.option_filter .from .content li a{display:inline-block;margin:0 2px;padding:0 7px;border-radius:4px}.option_filter .from .content li a.on{background:#ff4200;color:#fff}.option_filter .from .content .first{border-top:none}.option_filter .from .content .first .same_city{display:none;margin-left:10px}.option_filter .others{float:right;padding:0 10px;border:none;border-left:1px solid #e8e8e8}.option_filter .others .tag_option{float:left;position:relative;margin:0 1px 0 18px}.page-tmall .option_filter .from .content li a.on,.page-tmall .option_filter .price_area.out .shadow .confirm{background:#c40000}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"option_filter clearfix\"><div class=\"filter_area\"><div class=\"price_area\"><div class=\"shadow\">价格： <input mx-guid=\"g0\u001f\" id=\"priceRange_0\" class=\"rmb\" placeholder=\"¥\" value=\"<%= $$.root.url.minPrice%>\"><span>-</span><input mx-guid=\"g1\u001f\" id=\"priceRange_1\" class=\"rmb\" placeholder=\"¥\" value=\"<%= $$.root.url.maxPrice%>\"><a class=\"confirm\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dsortpricerange\">确定</a></div></div><div class=\"from cpnt_menu J_filter_citys\" data-spm=\"076265160012\"><span class=\"trigger\"><span id=\"from_value\">发货地</span><i></i></span></div><div class=\"others\"><a class=\"tag_option type_ship\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_ship\"><input mx-guid=\"g2\u001f\" id=\"status_ship\" type=\"checkbox\" name=\"ship\" <%if($$.root.url.ship==\"1\"){%> checked=\"checked\" <%}%>> 包邮</a><a class=\"tag_option type_itemAssurance\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_itemAssurance\"><input mx-guid=\"g3\u001f\" id=\"status_itemAssurance\" type=\"checkbox\" name=\"itemAssurance\" <%if($$.root.url.itemAssurance==\"1\"){%> checked=\"checked\" <%}%>> 正品保障</a><a class=\"tag_option type_exchange7\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_exchange7\"><input mx-guid=\"g4\u001f\" id=\"status_exchange7\" type=\"checkbox\" name=\"exchange7\" <%if($$.root.url.exchange7==\"1\"){%> checked=\"checked\" <%}%>> 7天退换</a><a class=\"tag_option type_custAssurance\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_custAssurance\"><input mx-guid=\"g5\u001f\" id=\"status_custAssurance\" type=\"checkbox\" name=\"custAssurance\" <%if($$.root.url.custAssurance==\"1\"){%> checked=\"checked\" <%}%>> 消费者保障</a></div></div></div>","subs":[{"keys":["root"],"path":"input[mx-guid=\"g0\u001f\"]","attr":"value=\"<%= $$.root.url.minPrice%>\"","attrs":[{"n":"value","q":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g1\u001f\"]","attr":"value=\"<%= $$.root.url.maxPrice%>\"","attrs":[{"n":"value","q":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g2\u001f\"]","attr":"<%if($$.root.url.ship==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g3\u001f\"]","attr":"<%if($$.root.url.itemAssurance==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g4\u001f\"]","attr":"<%if($$.root.url.exchange7==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g5\u001f\"]","attr":"<%if($$.root.url.custAssurance==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]}]},
    city: "<ol class=\"list content\"><li class=\"first\"><a href=\"#\" id=\"city_\">不限</a></li>{{#each citys}}<li>{{#each this}}<a href=\"#\" id=\"city_{{../../xindex}}_{{xindex}}\">{{this}}</a>{{/each}}</li>{{/each}}</ol>",
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Brick: null,
            XTemplate: null,
            Uri: null
        });
    },
    initOptionFilter: function initOptionFilter() {
        var S = this.opt.S,
            Brick = this.opt.Brick,
            XTemplate = this.opt.XTemplate,
            Uri = this.opt.Uri;

        var AREALIST = [['北京', '上海', '广州', '深圳', '杭州', '海外', '江浙沪', '京津冀', '港澳台'], ['长沙', '长春', '成都', '重庆', '大连', '东莞', '佛山', '福州', '贵阳', '合肥', '金华', '济南', '嘉兴', '昆明', '宁波', '南昌', '南京', '青岛', '泉州', '沈阳', '苏州', '天津', '温州', '无锡', '武汉', '西安', '厦门', '郑州', '中山', '石家庄', '哈尔滨'], ['安徽', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁', '宁夏', '青海', '山东', '山西', '陕西', '云南', '四川', '西藏', '新疆', '浙江', '澳门', '香港', '台湾', '内蒙古', '黑龙江']];

        var AreaTemplate = this.city; //S.one("#J_template_city") && S.one("#J_template_city").html()

        var queryString = location.search.length > 0 ? location.search.substring(1) : "";
        var queryArgs = S.unparam(queryString);

        var SelectLoc = null;
        if (queryArgs.loc) {
            S.each(AREALIST, function (items, index) {
                if (S.indexOf(queryArgs.loc, items) > -1) {
                    SelectLoc = index + "_" + S.indexOf(queryArgs.loc, items);
                }
            });
        }

        var C_URL = window.location.href;
        var OptionFilter = {
            bindUI: function bindUI() {
                // this.set("el", )
                S.one(".J_filter_citys").append(new XTemplate(AreaTemplate).render({
                    citys: AREALIST
                }));
                if (SelectLoc) {
                    S.one("#city_" + SelectLoc).addClass("on");
                    S.one("#from_value").html(queryArgs.loc.replace(/[<>]/ig, ""));
                }
            },
            bindEvent: function bindEvent() {
                S.one('.filter_area').on('click', OptionFilter.click_filter_area);
                S.one('.price_area').on('keyup', OptionFilter.keyup_price_area).on('focusin', OptionFilter.focusin_price_area);

                S.one(window).on('click', OptionFilter.click_window);
            },
            click_filter_area: function click_filter_area(e) {
                var target = S.one(e.target),
                    url;

                if (target[0].tagName == 'INPUT') {
                    target = target.parent();
                    target._from_input = true;
                }

                if (target[0].tagName != 'A') {
                    return;
                }

                url = target.attr('data-url');

                if (url === undefined) {

                    if (target[0].id.match(/^city_/) != null) {
                        url = new Uri(C_URL);
                        url.query.remove("spm");
                        if (target.html() == "不限") {
                            url.query.remove('loc');
                        } else {
                            url.query.set('loc', target.html());
                        }
                        url = url.toString();
                    } else if (target.hasClass('tag_option')) {
                        url = new Uri(C_URL);
                        if (target._from_input) {
                            //发生在input上
                            if (target.children('input').attr('checked') != 'checked') {
                                url.query.remove(target.children('input').attr('name'));
                            } else {
                                url.query.set(target.children('input').attr('name'), 1);
                            }
                        } else {
                            //发生在a上
                            if (target.children('input').attr('checked') != 'checked') {
                                url.query.set(target.children('input').attr('name'), 1);
                            } else {
                                url.query.remove(target.children('input').attr('name'));
                            }
                        }
                        url = url.toString();
                    } else if (target.hasClass('confirm')) {
                        url = new Uri(C_URL);
                        var input = target.parent().all('input'),
                            v1 = input[0].value,
                            v2 = input[1].value,
                            price = {},
                            priceStr;

                        //都有值的时候，大小位置无关，可以互换顺序
                        if (v1 && v2) {
                            price = {
                                min: Math.min(v1, v2),
                                max: Math.max(v1, v2)
                            };
                        } else {
                            price = {
                                min: v1,
                                max: v2
                            };
                        }

                        input[0].value = price.min;
                        input[1].value = price.max;
                        url.query.remove('minPrice');
                        url.query.remove('maxPrice');
                        if (price.min) {
                            url.query.set('minPrice', price.min);
                        }
                        if (price.max) {
                            url.query.set('maxPrice', price.max);
                        }
                    }
                }
                if (url == '') {
                    return;
                } else {
                    url = new Uri(url);
                    // 去其他参数
                    url.query.remove("page");
                }

                // url.query.set('prepvid', window.pvid);
                // url.query.set('spm', self.getFullSpm(target));
                if (target[0].tagName == "A" && target.attr("data-spm-anchor-id")) {
                    // 支持spm
                    url.query.set("spm", target.attr("data-spm-anchor-id"));
                }

                location.href = url.toString();
            },
            keyup_price_area: function keyup_price_area(e) {
                var target = S.all(e.target),
                    val = S.trim(target.val()),
                    dot = val.match(/\./g);

                if (e.target.tagName != 'INPUT') {
                    return;
                }

                //替换非数字字符
                val = val.replace(/[^0-9.]/g, '');

                //多余2个小数点,保留一个小数
                if (dot && dot.length > 1) {
                    val = val.match(/^[0-9]*\.[0-9]*/g)[0];
                }

                //保留两个小数点
                val = val.replace(/(\.\d\d)\d+/, "$1");

                target.val(val);
            },
            focusin_price_area: function focusin_price_area(e) {
                if (!S.one('.price_area').hasClass('out')) {
                    S.one('.price_area').addClass('out');
                }
            },

            click_window: function click_window(e) {
                var target = S.one(e.target);
                if (!target.parent('.price_area')) {
                    S.one('.price_area').removeClass('out');
                }
            }
        };

        OptionFilter.bindUI();
        OptionFilter.bindEvent();
    },

    render: function render() {
        var self = this;
        KISSY.use("xtemplate, uri", function (S, XTemplate, Uri) {
            self.opt.XTemplate = XTemplate;
            self.opt.Uri = Uri;
            self.updater.set({
                root: window.root || { url: {} }
            }).digest();
            self.initOptionFilter();
        });
    }
});

/***/ }),
/* 6 */
/***/ (function(module, exports) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2e",".pagination-pages .pagination-page{padding-top:12px;text-align:center}.pagination-pages a{color:#555}.pagination-pages .page,.pagination-pages .page-cur,.pagination-pages .page-next,.pagination-pages .page-prev{display:inline-block;width:34px;height:34px;line-height:34px;font-size:14px;text-align:center}.pagination-pages .page-cur{color:#fff;width:36px;height:36px;background:#f85300;line-height:36px}.pagination-pages .page{border:1px solid #ddd;background:#fff}.pagination-pages .page-split{margin:0 8px;font-size:14px}.pagination-pages .page-prev{margin-right:5px}.pagination-pages .page-next{margin-left:5px}.pagination-pages .page-next,.pagination-pages .page-prev{border:1px solid #ddd;background:#fff;width:45px;font-family:arial,verdana,sans-serif;line-height:35px;color:#333}.pagination-pages .pageJump{display:inline-block;width:45px;height:18px;line-height:18px;background:#f8f8f8;color:#999;text-align:center;vertical-align:middle;border:1px solid #ddd}.pagination-pages .pageJump input{width:45px;height:18px;border:0;text-align:center}.pagination-pages .text{color:#666;margin-left:15px;margin-right:5px}.pagination-pages .text2{margin-left:5px}.pagination-pages .totalPage{margin-left:30px;color:#666}.pagination-pages .pageConfirm{display:inline-block;margin-left:17px;line-height:20px;width:45px;height:18px;vertical-align:middle;background:#fff;color:#333;border:1px solid #ddd}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div id=\"J_waterfallPagination\" class=\"pagination\"></div>","subs":[]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Node: null
        });
    },
    initPagination: function initPagination() {
        var S = this.opt.S,
            Node = this.opt.Node;

        function Pagination(config) {
            this.configs = S.mix({
                index: 1,
                step: 3,
                // totalPages: 10,
                itemsPerPage: 50,
                totalItems: 300,
                showTotalPages: true,
                showLastPage: true,
                goToUrl: window.location.href,
                pageName: 'page',
                params: {},
                paramsArr: false
            }, config);
            // setup urlInfo
            this.urlInfo = this.parseUrl(this.configs.goToUrl);
            if (this.configs.params) {
                S.each(this.configs.params, function (k, v) {
                    this.urlInfo.params[k] = v;
                });
            }

            // set page information
            this.index = parseInt(this.urlInfo.params[this.configs.pageName], 10) || this.configs.index;
            this.totalPages = this.configs.totalPages || Math.ceil(this.configs.totalItems / this.configs.itemsPerPage);
        }

        S.mix(Pagination.prototype, {
            parseUrl: function parseUrl(url) {
                var a = document.createElement('a');
                a.href = url;
                return {
                    source: url,
                    protocol: a.protocol.replace(':', ''),
                    host: a.hostname,
                    port: a.port,
                    query: a.search,
                    params: function () {
                        return S.unparam(a.search.replace(/^\?/, ''));
                    }(),
                    file: (a.pathname.match(/\/([^\/?#]+)$/i) || [, ''])[1],
                    hash: a.hash.replace('#', ''),
                    path: a.pathname.replace(/^([^\/])/, '/$1'),
                    relative: (a.href.match(/tps?:\/\/[^\/]+(.+)/) || [, ''])[1],
                    segments: a.pathname.replace(/^\//, '').split('/')
                };
            },
            doUrl: function doUrl() {
                var self = this;
                var urlInfo = self.urlInfo;
                var index = self.index;
                var pageName = self.configs.pageName;
                var returnUrl;
                urlInfo.params[pageName] = index;
                urlInfo.params.keyword = decodeURI(window._SEARCHKEYWORDS);
                if (!urlInfo.params._input_charset) {
                    urlInfo.params._input_charset = 'utf-8';
                }
                returnUrl = urlInfo.protocol + '://' + urlInfo.host;
                if (urlInfo.port != 0 && urlInfo.port != 80) {
                    returnUrl += ':' + urlInfo.port;
                }
                returnUrl += urlInfo.path + '?';

                returnUrl += S.param(urlInfo.params, '&', '=', self.configs.paramsArr);
                if (urlInfo.hash != '') {
                    returnUrl += '#' + encodeURIComponent(urlInfo.hash);
                }
                return returnUrl;
            },
            render: function render(page) {
                var index = page || this.index;
                var step = this.configs.step;
                var seed = 1;
                var max = this.totalPages;
                var pageName = this.configs.pageName;
                var formatUrl = this.doUrl();
                var arrHTML = [];

                formatUrl = formatUrl.replace(pageName + '=' + index, pageName + '={$p}');
                arrHTML.push('<div class="pagination-pages"><div class="pagination-page">');
                if (index > 1) {
                    arrHTML.push('<a href="' + formatUrl.replace('{$p}', seed * (this.index - 1)) + '" class="page-prev iconfont">上一页</a>');
                }
                var start = Math.max(1, index - parseInt(step / 2, 10));
                var end = Math.min(max, start + step - 1);
                start = Math.max(1, end - step + 1);

                if (start >= 3) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 1) + '">1</a>');
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 2) + '">2</a>');
                    if (start > 3) {
                        arrHTML.push('<span class="page-split">...</span>');
                    }
                } else if (start == 2) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * 1) + '">1</a>');
                }

                for (var i = start; i <= end; i++) {
                    if (i === index) {
                        arrHTML.push('<span class="page-cur">' + i + '</span>');
                    } else {
                        arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * i) + '">' + i + '</a>');
                    }
                }
                if (end + 2 <= max) {
                    arrHTML.push('<span class="page-split">...</span>');
                    if (this.configs.showLastPage) {
                        arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * max) + '">' + max + '</a>');
                    }
                } else if (end < max) {
                    arrHTML.push('<a class="page" href="' + formatUrl.replace('{$p}', seed * max - 1) + '">' + max + '</a>');
                }

                if (index != max) {
                    arrHTML.push('<a href="' + formatUrl.replace('{$p}', seed * index) + '" class="page-next iconfont">下一页</a>');
                }
                arrHTML.push('<span class="totalPage">共' + max + '页</span>');
                arrHTML.push('<span class="text">去第</span><a href="javascript:;" class="pageJump"><input  id="Jumper" value="' + index + '" name="page" type="text"/></a><span class="text2">页</span><a  href="' + formatUrl.replace('{$p}', seed * index) + '" class="pageConfirm">确定</a>');
                // if (this.configs.showTotalPages) {
                //     arrHTML.push('<div class="pagination-count"><span>共</span><span class="b">' + max + '</span><span>页</span></div>');
                // }
                arrHTML.push('</div>');

                //render Jump
                //if (self.get('jump')) {
                //  arrHTML.push('<div class="pagination-form"><span>向第</span><input class="page-num" value="' + Math.min(max, index + 1) + '" name="page" type="text"><span>页</span><a class="btn-jump btn btn-size25">跳转</a></div>');
                // }

                arrHTML.push('</div>');

                S.one(this.configs.container).html(arrHTML.join(''));
            }
        });
        return Pagination;
    },
    renderPagination: function renderPagination(Pagination) {
        var S = this.opt.S;
        var pagination = new Pagination({
            container: '#J_waterfallPagination',
            totalPages: 100,
            pageName: 'page',
            showTotalPages: true,
            showLastPage: true
        });
        pagination.render();
        S.one('#Jumper').on('blur', function (e) {
            var page = Math.floor(Node(e.currentTarget).val());
            if (page < 0 || page > 100) {
                return;
            }
            var confirms = S.one('.pageConfirm'),
                url = confirms.attr('href');
            var newUrl = url.replace(/page=\d+/g, function (a, b, c) {
                return 'page=' + page;
            });
            confirms.attr('href', newUrl);
        });
    },
    render: function render() {
        var self = this;

        KISSY.use("node", function (S, Node) {
            self.opt.Node = Node;
            self.updater.set({}).digest();
            self.renderPagination(self.initPagination());
        });
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */


Magix.applyStyle("xf2a",".clearfix:after,.clearfix:before{display:table;content:\"\"}.clearfix:after{clear:both}.inline-block{display:inline-block;*display:inline;*zoom:1}.topsearch{height:90px;margin-bottom:20px}.ai-topsearch{font:12px/1.5 tahoma,microsoft yahei,\\\\5FAE\\8F6F\\96C5\\9ED1}.ai-topsearch a{color:#333;text-decoration:none}.ai-topsearch a:hover{color:#e22c37;text-decoration:none}.ai-topsearch .mainNav .red a{color:#ef470f}.ai-topsearch{-webkit-transition:all .3s;transition:all .3s;top:-60px}.con-wrap{width:990px;_width:990px;margin:0 auto;overflow:hidden}#site-nav{border-bottom:1px solid #eaeaea}#site-nav a{color:#999}.ai-topsearch{overflow:hidden;background:#fff}.ai-topsearch .search-wrap{float:left;width:100%}.ai-topsearch .search{margin-left:278px;margin-right:95px}.ai-topsearch .search .search-border{border:2px solid #ff4200;border-right:0;height:34px;margin-top:25px;position:relative}.ai-topsearch .search .btn-arrow{position:absolute;right:0;bottom:-10px;width:15px;height:7px;background:url(//img.alicdn.com/tps/i1/T1e3YIFchfXXajgF6X-15-7.png)}.ai-topsearch .search .label{float:left;height:34px;line-height:34px;width:75px;border-right:1px solid #efefef;text-align:center;background:#f6f6f6}.ai-topsearch .search .text-wrap{display:block;overflow:hidden;padding:6px 10px 5px;padding-right:110px;_width:318px}.ai-topsearch .search .text{height:23px;line-height:23px;font-size:14px;border:0 none;width:100%;outline:0}.ai-topsearch .search .txt-focus{background:0}.ai-topsearch .search .submit{width:95px;height:34px;border:0 solid #ff4200;position:absolute;top:0;right:0;background-color:#ff4200;color:#fff;font-size:16px}.ai-topsearch .search .search-links{padding:5px 0 0}.ai-topsearch .search .search-links a{margin-right:10px;color:#666}.ai-topsearch .ai-logo{width:213px;height:90px;float:left;margin-left:-100%;_display:inline}.ai-topsearch .ai-logo .logo{float:left;display:block;width:213px;height:73px;margin:25px 0 0;background:url(//img.alicdn.com/tps/TB1YZkPLpXXXXbzXXXXXXXXXXXX-213-57.png) no-repeat 0 0}.ai-topsearch .mainNav{overflow:hidden;font-size:12px;float:left;width:540px;height:27px;_margin-left:40px}.ai-topsearch .mainNav li{float:left;border-right:1px solid #fff;margin-right:10px;margin-top:10px;line-height:10px;height:12px;*height:14px;*vertical-align:middle;*line-height:16px}.ai-topsearch .mainNav li:last-child{border:none}.fixed .ai-topsearch{position:fixed;top:0;width:100%;height:60px;background:#fff;-webkit-box-shadow:0 0 4px 0 #eaeaea;box-shadow:0 0 4px 0 #eaeaea;z-index:1000}.fixed .ai-topsearch .ai-logo,.fixed .ai-topsearch .search-wrap{height:60px}.fixed .ai-topsearch .ai-logo .logo{margin-top:-3px;-webkit-transform:scale(.8);transform:scale(.8)}.fixed .ai-topsearch .search .search-border{margin-top:10px}.fixed .ai-topsearch .search .text-wrap{background:#fff}.fixed .ai-topsearch .mainNav,.fixed .ai-topsearch .search .search-links{display:none}.page-tmall .ai-topsearch .ai-logo .logo{background:url(//img.alicdn.com/tfs/TB1BI8jOVXXXXXVaFXXXXXXXXXX-111-26.png) no-repeat 50% 50%}.page-tmall .ai-topsearch .search .search-border{border-color:#c40000}.page-tmall .ai-topsearch .search .submit{background-color:#c40000}.page-tmall .fixed .ai-topsearch .ai-logo .logo{margin-top:-7px;-webkit-transform:scale(1);transform:scale(1)}#body1190 #J_SiteNav .site-nav-bd,#body1190 .ai-topsearch .con-wrap{width:1190px}#body1190 .ai-topsearch .mainNav{width:650px}#body1350 #J_SiteNav .site-nav-bd,#body1350 .ai-topsearch .con-wrap{width:1350px}#body1350 .ai-topsearch .mainNav{width:750px}@media screen and (min-width:1190px) and (max-width:1349px){#J_SiteNav .site-nav-bd,.ai-topsearch .con-wrap{width:1190px}.ai-topsearch .mainNav{width:700px}#sn-bd{width:1190px!important}}@media screen and (min-width:1350px){#J_SiteNav .site-nav-bd,.ai-topsearch .con-wrap{width:1350px}.ai-topsearch .mainNav{width:850px}#sn-bd{width:1350px!important}}.ks-popupmenu{position:absolute;left:-9999px;top:-9999px;background:#fff;z-index:1000;border:1px solid #e6e6e6}.ks-popupmenu .ks-menu-item-hover{background:#eee}.ks-popupmenu .ks-menu-item-hover .search-menu-list-item .search-menu-list-item-title .atbfont{float:right;margin-right:8px}.ks-popupmenu .search-menu-list-item{padding:5px 10px;color:#333;cursor:pointer;overflow:hidden}.ks-popupmenu .search-menu-list-item .search-menu-list-item-title{display:block;width:50%;height:18px;overflow:hidden}.ks-popupmenu .search-menu-list-item .search-menu-list-item-title .atbfont{color:#666;vertical-align:1px;margin-left:5px}.ks-popupmenu .search-tags-wrap{position:absolute;right:0;width:50%;top:0;height:100%}.ks-popupmenu .search-tags-wrap .search-tags-group{display:none;border-left:1px solid #e6e6e6;height:100%;overflow:hidden;background:#f8f8f8;padding:0 18px}.footer-toy,.ks-popupmenu .search-tags-wrap .search-tags-group-show{display:block}.ks-popupmenu .search-tags-wrap .search-tags-group h1{padding:32px 4px 10px 0;margin:0;font-size:12px;color:#666}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list{margin-bottom:20px}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li{float:left;white-space:nowrap;margin-left:-1px;margin-top:-1px}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li a{padding:5px 8px;width:50px;text-align:center;border:1px solid #cdcdcd;display:block;background-color:#fff;color:#777;text-decoration:none}.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li .hot,.ks-popupmenu .search-tags-wrap .search-tags-group .search-tags-list li a:hover{color:#ff5a00}");

var searchData = __webpack_require__(9);

module.exports = Magix.View.extend({
    tmpl: {"html":"<div mx-guid=\"g0\u001f\" id=\"J_topsearch\" class=\"topsearch\" data-spm=\"199828735011\" data-fixtop=\"<%= $$.fixtop%>\"><div class=\"ai-topsearch\"><div class=\"con-wrap clearfix\"><div class=\"search-wrap\"><div class=\"search\"><div class=\"search-border clearfix\" id=\"J_searchbox\"><form action=\"#\" id=\"J_searchForm\"><span class=\"text-wrap\"><input class=\"text ks-combobox-input\" placeholder=\"请输入要搜索的词\" id=\"q\" name=\"keyword\" accesskey=\"s\" autocomplete=\"off\" x-webkit-speech=\"\" x-webkit-grammar=\"builtin:translate\"></span><input type=\"hidden\" name=\"page\" value=\"0\"> <input type=\"submit\" class=\"submit\" value=\"搜索\" data-spm-click=\"gostr=/zz;locaid=dsearch\"></form></div><ul mx-guid=\"g1\u001f\" class=\"mainNav J_proxy_textlink\" data-pid=\"<%= $$.textlinkpid%>\" data-feload=\"1\"></ul></div></div><div class=\"ai-logo\"><span class=\"logo\" title=\"淘宝热卖\"></span></div></div></div></div>","subs":[{"keys":["fixtop"],"path":"div[mx-guid=\"g0\u001f\"]","attr":"data-fixtop=\"<%= $$.fixtop%>\"","attrs":[{"n":"data-fixtop"}]},{"keys":["textlinkpid"],"path":"ul[mx-guid=\"g1\u001f\"]","attr":"data-pid=\"<%= $$.textlinkpid%>\"","attrs":[{"n":"data-pid"}]}]},
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            ComboBox: null,
            XTemplate: null
        });
    },
    initSearchBox: function initSearchBox() {
        var S = this.opt.S,
            ComboBox = this.opt.ComboBox,
            XTemplate = this.opt.XTemplate;

        return searchBox = {
            init: function init() {
                var self = this;
                self._bindSuggest();
            },
            startSearch: function startSearch(word) {
                var self = this,
                    formNode = S.one('#J_searchForm');

                if (word === undefined || word === '') {
                    return false;
                }

                formNode.one('.text').val(word);
                formNode.fire('submit');
            },
            _handleHoverItem: function _handleHoverItem(node) {
                var self = this,
                    index = node.attr('data-index'),
                    dstTagNode = S.one('#J_tag_group_' + index);

                S.all('.search-tags-group').removeClass('search-tags-group-show');

                if (index && dstTagNode) {
                    self.currentTagTitle = node.attr('data-title');
                    dstTagNode.one('.right-title').html(self.currentTagTitle);
                    dstTagNode.addClass('search-tags-group-show');
                }
            },
            _bindSuggest: function _bindSuggest() {
                var self = this,
                    rightTagTmpl = '<div class="search-tags-wrap">' + '{{#each magics}}' + '<div id="J_tag_group_{{index}}" class="search-tags-group">' + '<h1 class="right-title">{{searchWords}}</h1>' + '{{#each data}}' + '<ul class="search-tags-list clearfix">' + '{{#each this}}' + '<li><a href="#" class="search-tags-word">{{title}}</a></li>' + '{{/each}}' + '</ul>' + '{{/each}}' + '</div>' + '{{/each}}' + '</div>';
                S.one(document).delegate('mouseenter', '.ks-menuitem', function (e) {
                    self.inTagWrap = false;
                    S.one(e.currentTarget).siblings().removeClass('ks-menu-item-hover');
                    S.one(e.currentTarget).addClass('ks-menu-item-hover');
                });

                S.one(document).delegate('mouseenter', '.search-tags-wrap', function (e) {
                    self.inTagWrap = true;
                });

                S.one(document).delegate('mouseenter', '.search-menu-list-item', function (e) {
                    self._handleHoverItem(S.one(e.currentTarget));
                });

                S.one(document).delegate('mouseleave', '.ks-menuitem', function (e) {
                    S.later(function () {
                        !self.inTagWrap && S.one(e.currentTarget).removeClass('ks-menu-item-hover');
                    }, 100);
                });

                S.one(document).delegate('click', '#q', function (e) {
                    if (!self.basicComboBox) return;
                    var value = S.one(e.currentTarget).val();
                    value && self.basicComboBox.sendRequest(value);
                });

                S.one(document).delegate('click', '.search-tags-word', function (e) {
                    var word = S.one(e.currentTarget).html();

                    word = self.currentTagTitle.replace(/<[^>]+>/g, '') + ' ' + word;
                    self.startSearch(word);
                });
                S.one('#J_searchForm').on('submit', function (e) {
                    var form = S.one(e.currentTarget);
                    var node = form.one('.text');
                    //node.val(encodeURIComponent(node.val()))
                    if (/[<>]/.test(node.val())) {
                        //判断搜索框有没有特殊字符，有的话进行替换去掉。
                        node.val(node.val().replace(/<[^>]+>/g, '').replace(/[<>]/g, ''));
                    }
                });
                function _injectTagGroup(query, magics) {
                    var str = new XTemplate(rightTagTmpl).render({
                        magics: magics,
                        searchWords: query
                    });

                    if (!self.popMenu) {
                        self.popMenu = S.one('.ks-popupmenu');
                    }

                    if (self.popMenu) {
                        self.popMenu.one('.search-tags-wrap') && self.popMenu.one('.search-tags-wrap').remove();
                        self.popMenu.append(str);
                    }
                }

                self.basicComboBox = new ComboBox({
                    srcNode: S.one('#J_searchbox'),
                    input: S.one('#J_searchForm').one(".text"),
                    hasTrigger: false,
                    dataSource: new ComboBox.RemoteDataSource({
                        xhrCfg: {
                            url: '//suggest.taobao.com/sug?code=utf-8&area=c2c',
                            dataType: 'jsonp',
                            data: {
                                code: 'utf-8'
                            }
                        },
                        paramName: 'q',
                        cache: false,
                        parse: function parse(query, results) {
                            var list = results.result,
                                magics = results.magic,
                                filterMagics = [];

                            S.each(magics, function (m) {
                                //剔除掉除tag_group的其他类型的词
                                if (m.type == 'tag_group') {
                                    filterMagics.push(m);
                                    //返回的标识是从1开始的，所以要减一；
                                    list[parseInt(m.index) - 1].push(true);
                                }
                            });
                            S.later(function () {
                                //S.one('.ks-popupmenu').css('top',(S.one('.search-border').offset().top+39)+'px');
                                _injectTagGroup(query, filterMagics);
                            }, 300);

                            return list;
                        }
                    }),
                    format: function format(query, results) {
                        var ret = [],
                            tmpl = '<div class="search-menu-list-item" data-title="{{text}}" data-index="{{index}}">' + '<span class="search-menu-list-item-title">{{{text}}}{{#hasTag}}<i class="atbfont">></i>{{/hasTag}}</span>' + '</div>',
                            queryReg = new RegExp('^' + query);

                        S.each(results, function (re, index) {
                            //发现主搜返回的数据，有时会有特殊标记，所以这边需要处理一下。
                            re[0] = re[0].replace(/<[^>]+>/g, '');

                            ret.push({
                                textContent: re[0],
                                content: new XTemplate(tmpl).render({
                                    //是汉字，并且以query开头需要做特殊处理
                                    text: queryReg.test(re[0]) ? query + '<b>' + re[0].replace(queryReg, '') + '</b>' : re[0],
                                    count: re[1],
                                    hasTag: re[2],
                                    index: index + 1
                                })
                            });
                        });

                        return ret;
                    }
                });

                self.basicComboBox.render();

                self.basicComboBox.on('click', function (e) {
                    self.startSearch(e.target.get('value')[0]);
                });
            },
            inTagWrap: false
        };
    },
    renderSearchBox: function renderSearchBox() {
        var S = this.opt.S;
        var $ = S.all;

        //搜索框聚焦
        S.one('#q').on('keyup', function (e) {
            var val = $(e.target).val();
            if (val.length == '') {
                $(e.target).removeClass('txt-focus');
            } else {
                $(e.target).addClass('txt-focus');
            }
        });

        // navigation links' parameters setup
        var DEFAULT_REFPID = 'mm_14507511_3485205_11375261';
        var queryString = location.search.length > 0 ? location.search.substring(1) : "";
        var queryArgs = S.unparam(queryString);
        var pidforLogo = queryArgs.pid || queryArgs.refpid || '';
        delete queryArgs.tab;
        delete queryArgs.buckid;

        S.each(queryArgs, function (val, key) {
            if (S.isArray(val)) queryArgs[key] = val[0];
        });

        if (queryArgs.refpid && queryArgs.pid) delete queryArgs.pid;
        if (queryArgs.pid) {
            queryArgs.refpid = queryArgs.pid || '';
            delete queryArgs.pid;
        }

        // search box parameter setup
        // 透传参数
        var transmitParam = {
            "refpid": queryArgs.refpid || queryArgs.pid || DEFAULT_REFPID,
            "buckid": queryArgs.buckid || '',
            "b": queryArgs.b || '',
            "clk1": queryArgs.clk1 || ''
        };
        S.each(transmitParam, function (val, k) {
            if (val === "") {
                delete transmitParam[k];
            }
        });

        var transmitParamInput = [];
        S.each(transmitParam, function (val, k) {
            var input = S.DOM.create('<input>', {
                type: 'hidden',
                name: k,
                value: val
            });
            transmitParamInput.push(input);
        });
        var searchForm = S.one('#J_searchForm');
        searchForm.attr('target', '_blank').attr('action', location.pathname).prepend(transmitParamInput);

        // 判断搜索下的文字链, 为了透传 clk1, 代理文字链，
        S.Event.delegate(".J_proxy_textlink", "click", "a", function (e) {
            var a = S.one(e.currentTarget);
            var param = S.clone(transmitParam);
            param.keyword = a.html();
            if (a.attr("data-spm-anchor-id")) {
                param.spm = a.attr("data-spm-anchor-id");
            }
            if (a.parent(".J_proxy_textlink").attr("data-linkpid")) {
                param["linkpid"] = a.parent(".J_proxy_textlink").attr("data-linkpid");
            }
            a.attr("href", location.pathname + "?" + S.param(param));
        });

        setTimeout(function () {
            this.fixTop();
        }.bind(this), 500);
        this.loadTextLink(transmitParam.refpid);
        //搜索框默认选值
        if (window._SEARCHKEYWORDS && window._SEARCHKEYWORDS != 'undefined') {
            S.one('#q') && S.one('#q').addClass('txt-focus').val(decodeURIComponent(window._SEARCHKEYWORDS));
            S.one('#qSupply') && S.one('#qSupply').addClass('txt-focus').val(decodeURIComponent(window._SEARCHKEYWORDS));
        }
    },
    loadTextLink: function loadTextLink(refpid) {
        var S = this.opt.S;
        var DOM = S.DOM;
        var nav = S.one('.mainNav');
        var pid = nav && nav.attr("data-pid") || '430709_1007';

        if (!nav.attr("data-feload")) {
            return;
        }

        S.ajax({
            url: '//textlink.simba.taobao.com/lk?pid=' + pid + '&refpid=' + refpid,
            data: {},
            dataType: 'jsonp',
            success: function success(d) {
                showCategory(d);
            }
        });

        function showCategory(d) {
            var categories = d.data,
                itemLists = [];

            S.each(categories, function (thisItem, idx) {
                if (idx > 15) {
                    return;
                }
                var li = idx <= 2 ? DOM.create('<li class="red">') : DOM.create('<li>');
                var a = DOM.create('<a>', {
                    href: thisItem[1],
                    text: thisItem[0],
                    'class': 'mainNavItem',
                    target: '_blank'
                });
                DOM.append(a, li);
                itemLists.push(li);
            });
            nav.append(itemLists);
        };
    },
    fixTop: function fixTop() {
        // 判断是否搜索置顶
        var S = this.opt.S;
        var topsearch = S.one("#J_topsearch");
        var items = S.one('#searchResult') || S.one('#items');
        if (topsearch.attr("data-fixtop") && topsearch.attr("data-fixtop") == 'true' && items) {
            var search_fixed = false;
            S.one(window).on("scroll", function () {
                var position = S.DOM.scrollTop(),
                    top = items.offset().top;
                if (position >= top) {
                    if (!search_fixed) {
                        search_fixed = true;
                        topsearch.addClass('fixed');
                    }
                } else {
                    if (search_fixed) {
                        search_fixed = false;
                        topsearch.removeClass('fixed');
                    }
                }
            });
        }
    },
    render: function render() {
        var self = this;
        KISSY.use("combobox,xtemplate,event", function (S, ComboBox, XTemplate) {
            self.opt.ComboBox = ComboBox;
            self.opt.XTemplate = XTemplate;

            self.updater.set({
                root: window.root,
                textlinkpid: self.opt.textlinkpid,
                fixtop: self.opt.fixtop || "true"
            }).digest();
            self.initSearchBox().init();
            self.renderSearchBox();
        });
    }
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

var Util = __webpack_require__(0);

Magix.applyStyle("xf2c",".related-search-outer .related-search{height:41px;line-height:41px;background:#f5f5f5;border:1px solid #e9e9e9;overflow:hidden;padding:0 0 0 19px}.related-search-outer .related-search dt{font-weight:400;float:left;color:#747474;margin:0 -2px 0 0;font-size:12px}.related-search-outer .related-search dd{float:left;font-size:12px}.related-search-outer .related-search dd a{border-right:1px solid #666;padding:0 13px 0 12px;color:#333;text-decoration:none}.related-search-outer .related-search dd a:hover{color:#ef470f}");

module.exports = Magix.View.extend({
  tmpl: {"html":"1\u001d","subs":[{"keys":["entity"],"path":"#\u001f","tmpl":"<%if($$.entity&&$$.entity.length>0){%><div id=\"J_stextlink\" class=\"related-search-outer\"><dl mx-guid=\"g1\u001f\" class=\"related-search J_proxy_textlink\" data-linkpid=\"<%= $$.linkpid%>\">2\u001d</dl></div><%}%>","s":"1\u001d"},{"keys":["linkpid","entity"],"path":"dl[mx-guid=\"g1\u001f\"]","tmpl":"<dt>您是不是想找:</dt><%$$.entity.forEach(function(a){%><dd><a href=\"<%= a.clickUrl%>&page=0\"><%= a.title%></a></dd><%})%>","s":"2\u001d","attr":"data-linkpid=\"<%= $$.linkpid%>\"","attrs":[{"n":"data-linkpid"}],"mask":"21"}]},
  ctor: function ctor(opt) {
    this.opt = $.extend(true, opt, {
      S: KISSY
    });
  },
  render: function render() {
    var S = this.opt.S,
        self = this;

    Util.sync(self.opt.p4ptextlink, {}, function (json) {

      self.updater.set({
        entity: json.data.data1,
        linkpid: self.opt.linkpid
      }).digest();

      var con = S.one('.related-search');
      var anchor = S.all('a', con);
      S.each(anchor, function (item) {
        item.href = item.href.replace(/&amp;/g, '&');
      });
    });
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

module.exports = {
    "success": true,
    "message": "",
    "result": ["鲜花速递", "除湿机", "跑步机", "蛋糕", "平板电脑", "电视挂架", "电脑桌", "连衣裙", "冬季拖鞋"]

};

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.addView("app/views/searchheader/index",__webpack_require__(7));;
Magix.addView("app/views/textlinks/index",__webpack_require__(8));;
Magix.addView("app/views/optionfilter/index",__webpack_require__(5));;
Magix.addView("app/views/itemcollections/index",__webpack_require__(4));;
Magix.addView("app/views/pagination/index",__webpack_require__(6));;
Magix.addView("app/views/hotsellitem/index",__webpack_require__(3));;
Magix.addView("app/views/backtop/index",__webpack_require__(2));;

// 用来处理异步加载时的路径寻找问题，如果不需要异步可以删除
~function () {
    var js = document.scripts;
    var url = js[js.length - 1].src;
    var urlScript = url.split('/');
    urlScript.pop();
    urlScript.pop();
    __webpack_require__.p = urlScript.join('/') + '/';
}();

// KISSY.config({
//     // 开启自动 combo 模式
//     combine:true});

KISSY.use('node,event,ajax', function () {

    Magix.config({
        rootId: 'body1240' // 容器id
        //   defaultView: 'app/tbbody'
    });
    // 开始初始化
    Magix.boot();
});

KISSY.ready(function () {
    var version = parseInt(KISSY.UA.ie, 10);
    var S = KISSY;
    window._SEARCHKEYWORDS = window.root.url.keyword || '连衣裙'; //S.one('#_SEARCHKEYWORDS').val();
    function ajustScreen() {
        var width = getBrowserWidth();
        if (width >= 1350) {
            S.one('body').attr('id', 'body1350');
        } else if (width < 1349 && width >= 1190) {
            S.one('body').attr('id', 'body1190');
        } else {
            S.one('body').attr('id', 'body-normal');
        }
    }
    function getBrowserWidth() {
        if (window.innerWidth) {
            return window.innerWidth;
        } else if (document.documentElement && document.documentElement.clientWidth != 0) {
            return document.documentElement.clientWidth;
        } else if (document.body) {
            return document.body.clientWidth;
        }
        return 0;
    }
    if (version && version <= 8) {
        ajustScreen();
        S.one(window).on('resize', function () {
            ajustScreen();
        });
    }
});

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// tmsearch/index.js